import React from "react";
import { NextSeo } from "next-seo";
import { InstantValuationToolMasthead } from "components/pages/InstantValuationTool/InstantValuationToolMasthead";
import { ProductPageBody } from "components/templates/ProductPage/ProductPageBody";
import { ProductPageCTA } from "components/templates/ProductPage/ProductPageCTA";
import { ProductPageFAQs } from "components/templates/ProductPage/ProductPageFAQs";
import { ProductPagePricing } from "components/templates/ProductPage/ProductPagePricing";
import { ProductPageFeatures } from "components/templates/ProductPage/ProductPageFeatures";
import { ProductPageHowItWorks } from "components/templates/ProductPage/ProductPageHowItWorks";
import { IProduct } from "interfaces/product.interface";

export const InstantValuationTool = ({ data }: { data: IProduct }) => {
  const { name, features, faqs, howItWorks } = data;

  return (
    <>
      <NextSeo title={`LeadPro – ${name}`} />
      <InstantValuationToolMasthead product={data} />
      <ProductPageBody>
        {howItWorks && <ProductPageHowItWorks product={data} />}
        {features && <ProductPageFeatures product={data} />}
        <ProductPagePricing product={data} />
        {faqs && <ProductPageFAQs product={data} />}
        <ProductPageCTA product={data} />
      </ProductPageBody>
    </>
  );
};
